import { AfterViewChecked, Directive, ElementRef } from '@angular/core';

// Opens anchors inside [innerHTML] content in a new browser tab.
// Apply alongside [innerHTML] (e.g. T&Cs / privacy notice) where the HTML
// is rendered from a string and so cannot use Angular template bindings.

@Directive({
  selector: '[appExternalLinks]',
})
export class ExternalLinksDirective implements AfterViewChecked {
  constructor(private el: ElementRef<HTMLElement>) {}

  // innerHTML is re-rendered asynchronously, so re-apply after each check.
  ngAfterViewChecked(): void {
    const anchors = this.el.nativeElement.querySelectorAll('a');
    anchors.forEach((anchor) => {
      anchor.setAttribute('target', '_blank');
      // Prevent the new tab from accessing window.opener.
      anchor.setAttribute('rel', 'noopener noreferrer');
    });
  }
}
